import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import { employeeLegalEntity } from 'modules/core/lib/employeeLegalEntity'
import LegalEntity from 'modules/core/store/models/LegalEntity'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'

import Daypicker from './Daypicker'
import HolidaysOverview from './HolidaysOverview'
import PendingApprovals from './PendingApprovals'
import PreWarning from './PreWarning'
import ReassignManagerSelect from './ReassignManagerSelect'
import TerminationObservation from './TerminationObservation'
import TerminationReason from './TerminationReason'
import TerminationTypeList from './TerminationTypeList'
import Warning from './Warning'

interface Props {
  isEligibleForPayroll: boolean
  employee: Employee
  form: Form
  isFiredByCompany: boolean
  contractVersions: ContractVersions
}

const FirstStep = ({
  employee,
  form,
  isEligibleForPayroll,
  isFiredByCompany,
  contractVersions,
}: Props) => {
  const legalEntity = employeeLegalEntity(employee)
  const isSpanishLegalEntity = legalEntity.country == LegalEntity.countryDefaults.es
  const isFrenchLegalEntity = legalEntity.country == LegalEntity.countryDefaults.fr

  return (
    <>
      <FormRow>
        <Daypicker form={form} isEligibleForPayroll={isEligibleForPayroll} />
      </FormRow>
      {(isSpanishLegalEntity || isFrenchLegalEntity) && (
        <FormRow>
          <TerminationTypeList form={form} country={legalEntity.country} />
        </FormRow>
      )}
      {!isSpanishLegalEntity && !isFrenchLegalEntity && (
        <FormRow>
          <TerminationReason form={form} />
        </FormRow>
      )}

      <FormRow>
        <TerminationObservation form={form} />
      </FormRow>

      <FormRow>
        <ReassignManagerSelect
          form={form}
          employee={employee}
          contractVersions={contractVersions}
        />
      </FormRow>
      <FormRow>
        <PendingApprovals form={form} accessId={employee.attributes.access_id} />
      </FormRow>

      {isEligibleForPayroll && (
        <>
          <PreWarning isFiredByCompany={isFiredByCompany} form={form} />
          <Box
            paddingY="s24"
            border={{
              top: {
                width: 's1',
                style: 'solid',
                color: 'darker160',
              },
            }}
          >
            <HolidaysOverview employee={employee} />
          </Box>
        </>
      )}

      <Box
        paddingTop="s24"
        border={{
          top: {
            width: 's1',
            style: 'solid',
            color: 'darker160',
          },
        }}
      >
        <Warning />
      </Box>
    </>
  )
}

export default observer(FirstStep)
